import React from "react";
import Tray from "~/modules/Tray/Video";

const MoreClassesTray = props => {
  const trayProps = {
    noBlockTitle: true,
    data: {
      title: `MORE ${props.title ? props.title.toUpperCase() : ""} CLASSES`,
      contentData: props.data,
      settings: {
        seeAll: false,
        seeAllPermalink: "#"
      }
    },
    layout: {
      settings: {
        loop: false,
        infoHover: true,
        thumbnailType: "landscape",
        columns: {
          desktop: 4,
          mobile: 1,
          tablet: 3,
          ott: 6
        }
      }
    }
  };
  return (
    <div className="netflix-tray">
      <Tray
        {...trayProps}
        showCount={false}
        netflix={true}
        hideCategories={true}
        showPlayIcon={true}
        showProgressBar={true}
        neouTrayTitle={true}
      />
    </div>
  );
};

export default MoreClassesTray;
